import '../components/FlowStats.scoped.scss'

export default function StepStatBox({ value, label, isFirst = false }) {
  return (
    <div className={`primary-action ${isFirst ? 'first' : ''}`}>
      <p className='number'>{value}</p>
      <p className='label'>{label}</p>
    </div>
  )
}
